<section id="section07">

  <div class="container">

    <img class="quotes-decoration" src="assets/imagens/quotes.png" alt="alternative">

    <div class="section-header">
      <h2>{{ data.TITULO }}</h2>
    </div>

    <div id="carouselSection07" class="carousel slide" data-ride="carousel">

      <ol class="carousel-indicators">
        <li *ngFor="let depoimento of data.DEPOIMENTOS; let index = index" data-target="#carouselSection07" [attr.data-slide-to]="index" [ngClass]="{ 'active': index == 0 }"></li>
      </ol>

      <div class="carousel-inner">

        <div class="carousel-item" [ngClass]="{'active' : index == 0 }"
          *ngFor="let depoimento of data.DEPOIMENTOS; let index = index">

          <div class="row d-flex justify-content-center align-items-center">
            <div class="col-lg-12">
              <div class="depoimento">
                <b>{{ depoimento.NOME }}</b>
                <p class="m-0">{{ depoimento.CARGO }}</p>
                <p class="m-0">{{ depoimento.OPERACAO }}</p>
                <b>{{ depoimento.EMPRESA }}</b>

                <p class="card-text mt-4">{{ depoimento.DESCRICAO }}</p>
              </div>
            </div>
          </div>

        </div>

      </div>

      <a class="carousel-control-prev" href="#carouselSection07" role="button" data-slide="prev">
        <i class="fa fa-angle-left fa-2x" aria-hidden="true"></i>
        <span class="sr-only">Previous</span>
      </a>

      <a class="carousel-control-next" href="#carouselSection07" role="button" data-slide="next">
        <i class="fa fa-angle-right fa-2x" aria-hidden="true"></i>
        <span class="sr-only">Next</span>
      </a>

    </div>

  </div>

</section>